import { useEffect } from 'react';
import { NEW_VIEW } from '@/constants/dashboardConstants';
import { useHistory, useParams } from 'react-router';
import { EXPERIMENT_TAB_PATHNAME } from '@experiment-management-shared/constants/experimentConstants';
import { DashboardRouteParams } from '@experiment-management-shared/types';
import useProjectViews from '@API/project/useProjectViews';

const SECTION_NAMES = Object.values(EXPERIMENT_TAB_PATHNAME);

const useEMDashboardRedirect = ({ section }: { section?: string }) => {
  const history = useHistory();
  const { projectName, viewId, workspace } = useParams<DashboardRouteParams>();
  const {
    data: templates = [],
    isLoading: isLoadingTemplates
  } = useProjectViews();

  useEffect(() => {
    if (isLoadingTemplates) {
      return;
    }

    const template = viewId
      ? templates.find(template => template.templateId === viewId)
      : null;
    const defaultTemplate = templates.find(template => template.projectDefault);
    const validViewId =
      (template || viewId === NEW_VIEW
        ? viewId
        : defaultTemplate?.templateId) ?? NEW_VIEW;
    const validSection = SECTION_NAMES.includes(section || '')
      ? section
      : EXPERIMENT_TAB_PATHNAME.panels;

    const newPathname = `/${workspace}/${projectName}/view/${validViewId}/${validSection}`;

    if (newPathname === history.location.pathname) return;

    history.replace({ ...history.location, pathname: newPathname });
  }, [
    history,
    isLoadingTemplates,
    projectName,
    section,
    templates,
    viewId,
    workspace
  ]);
};

export default useEMDashboardRedirect;
